import { Rect } from "..";
import { Shader } from "../../components/BaseComponents";

export class Gradient {
  createShader(rect: Rect): Shader {
    // TODO
    return null;
  }
}
